import { notifications } from '@mantine/notifications';

import { ApiResponseError } from '@/apis/http';

import {
  getPermissionErrorPayload,
  isPermissionError,
  showPermissionNotification,
} from './permission-error';

const onApiError = (error: ApiResponseError) => {
  // Check if this is a permission error with structured payload
  if (isPermissionError(error)) {
    const payload = getPermissionErrorPayload(error);
    if (payload) {
      showPermissionNotification(payload);
      return;
    }
  }

  const isRateLimited =
    error?.code === 429 || /too many requests|throttlerexception/i.test(error?.message || '');
  const message = isRateLimited
    ? 'You have sent several requests recently. Please wait a few minutes and try again.'
    : error?.message;

  // Default error notification
  notifications.show({
    title: 'Error',
    message,
    color: 'red',
  });
};

export default onApiError;
